module.exports = __webpack_public_path__ + "static/media/desktopLandscapeExample.001b41b8.png";